import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';

const LoadSpin = (props) => {
    return (
        <Spinner size={SpinnerSize.medium} />
    );
}

export default LoadSpin;